export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["ACQ131"] = "acqci-acq-131";
  ExperimentKeys["BIAB004"] = "biab-004";
  ExperimentKeys["ACQ128"] = "acq-128";
  ExperimentKeys["ACQ133"] = "acq-0133";
  ExperimentKeys["GOSU025B"] = "gosu-025b";
  ExperimentKeys["GOSU0001"] = "gosu-0001";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';